import Row from "antd/lib/grid/row";
import styled from "styled-components";

export const SignupRow = styled(Row)`
  margin-top: 200px;
`;
